<template>
<div class="w100">
  <!-- <transition name="modal-fade"> -->
    <div class="modal-backdrop" v-on:click="ClickOutside()">
    </div>
    <div class="modal" role="dialog" >
      <header class="modal-header" id="modalTitle" >
        <slot name="header">
          <div ref="Titulo"></div>
        </slot>
      </header>
      <section class="modal-body mT10" id="modalDescription" >

        <div class="face face-front oHidden">
          <div class="content aliCenter">
            <!-- <div class="TituloLogin B">Login</div> -->
            <div class="">
              <div class="field-wrapper">
                <input v-model="InfoEstablecimiento._Nombre" type="text" placeholder="Nombre" />
                <label>Nombre</label>
              </div>
              <div class="field-wrapper">
                <input v-model="InfoEstablecimiento._Localidad" type="text" placeholder="Localidad" />
                <label>Localidad</label>
              </div>
              <div class="field-wrapper">
                <input v-model="InfoEstablecimiento._Latitud" type="text" placeholder="Latitud" />
                <label>Latitud (ej: -31.0302)</label>
              </div>
              <div class="field-wrapper">
                <input v-model="InfoEstablecimiento._Longitud" type="text" placeholder="Longitud" />
                <label>Longitud (ej: -31.0302)</label>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-footer">
          <button type="button" class="Boton BotonCancelar" @click="Cerrar" >Cancelar</button>
          <button type="button" class="Boton BotonAceptar" @click="Aceptar()" >Aceptar</button>
      </footer>
    </div>
  <!-- </transition> -->

</div>
</template>
<script>
  import axios from "axios";
  export default {
    name: 'ModalNuevoEstablecimiento',
    data() {
      return {
        InfoEstablecimiento: {
          _Id: 0,
          _IdProductor: 0,
          _Nombre: "",
          _Localidad: "",
          _Latitud: "",
          _Longitud: ""
        },
        _Caso: 1// 1 Insertar, 2 Editar
      };
    },
    mounted() {
    },
    created(){

    },
    methods: {
      Cerrar() {
        this.$emit('Cerrar');
      },
      ClickOutside(){
        if(this._Caso == 2){
          this.LimpiarDatos();
        }
        this.$emit('Cerrar');
      },
      Editar(_E){
        this.$refs.Titulo.innerHTML = "Editando...";
        this._Caso = 2;
        this.InfoEstablecimiento._Id = _E._Id;
        this.InfoEstablecimiento._IdProductor = 0;
        this.InfoEstablecimiento._Nombre = _E._Nombre;
        this.InfoEstablecimiento._Localidad = _E._Localidad;
        this.InfoEstablecimiento._Latitud = _E._Latitud;
        this.InfoEstablecimiento._Longitud = _E._Longitud;
        //this.InfoEstablecimiento = _E;
      },
      SetearPorNuevo(_IdProductor){
        this.InfoEstablecimiento._IdProductor = _IdProductor;
        this.$refs.Titulo.innerHTML = "Nuevo...";
        this._Caso = 1;
      },
      async Aceptar() {
        try {
          if(this.InfoEstablecimiento._Latitud.indexOf(".") <= -1){
            this.$parent.$parent.Notificacion("La Latitud debe contener un valor que contenga un punto!", "", "error", 3);
            return;
          }
          if(this.InfoEstablecimiento._Longitud.indexOf(".") <= -1){
            this.$parent.$parent.Notificacion("La Longitud debe contener un valor que contenga un punto!", "", "error", 3);
            return;
          }
          this.InfoEstablecimiento._Nombre = this.InfoEstablecimiento._Nombre.trim();
          this.InfoEstablecimiento._Localidad = this.InfoEstablecimiento._Localidad.trim();
          this.InfoEstablecimiento._Latitud = this.InfoEstablecimiento._Latitud.trim().ObtenerNumero();
          this.InfoEstablecimiento._Longitud = this.InfoEstablecimiento._Longitud.trim().ObtenerNumero();
          //Una vez convertido con el ObtenerEntero, el tipo cambia a "number"
          //return;
          if (this.Validaciones()){
            switch (this._Caso){
              case 1:
                //ALTA
                if (await this.SolicitoAltaEstablecimiento()){
                  this.LimpiarDatos();
                  this.$parent.CerrarModal();
                  this.$parent.ObtenerDatos();
                }
                break;
              default:
                //EDICION
                if (await this.SolicitoEdicionEstablecimiento()){
                  this.LimpiarDatos();
                  this.$parent.CerrarModal();
                  this.$parent.ObtenerDatos();
                }
                break;
            }
          }
        } catch (error) {
          console.error(error);
        }
      },
      async SolicitoAltaEstablecimiento(){
        var _Retorno = false;
        try {
          var _This = this;
          var _User = _This.$parent.$parent.Datos._User;
          await axios
              .post(_This.urlPosts + "/AgroIdeas/AltaEstablecimiento", {
                IdUsuario: _User._ID,
                InfoEstablecimiento: _This.InfoEstablecimiento
              })
              .then(function (response) {
                if (response.data == ""){
                  _Retorno = true;
                  _This.$parent.$parent.Notificacion("Establecimiento creado!", "", "success", 3);
                }else{
                  _This.$parent.$parent.Notificacion(response.data, "", "error", 3);
                }
              })
              .catch(function (error) {
                console.log(error);
                _This.$parent.$parent.Notificacion("Error!", "", "error", 3);
              })
              .then(function () {});
        } catch (error) {
          console.error(error);
        }
        return _Retorno;
      },
      async SolicitoEdicionEstablecimiento(){
        var _Retorno = false;
        try {
          var _This = this;
          var _User = _This.$parent.$parent.Datos._User;
          await axios
              .post(_This.urlPosts + "/AgroIdeas/EdicionEstablecimiento", {
                IdUsuario: _User._ID,
                InfoEstablecimiento: _This.InfoEstablecimiento
              })
              .then(function (response) {
                if (response.data != ""){
                  _This.$parent.$parent.Notificacion(response.data, "", "success", 3);
                  _Retorno = true;
                }else{
                  _This.$parent.$parent.Notificacion("Error1!", "", "error", 3);
                }
              })
              .catch(function (error) {
                console.log(error);
                _This.$parent.$parent.Notificacion("Error!", "", "error", 3);
              })
              .then(function () {
                console.log("---");
              });
        } catch (error) {
          console.error(error);
        }
        return _Retorno;
      },
      Validaciones(){
        var _Retorno = true;
        try {
            if (this.InfoEstablecimiento._Nombre.length < 2){
              this.$notify({
                group: 'Notificaciones',
                title: 'Nombre inválido!',//Puede ser HTML
                type: 'error',
                speed: 500,
                duration: 3000,
                // text: 'Hello user! This is a notification!'//Puede ser HTML
              });
              _Retorno = false;
            }
            if (this.InfoEstablecimiento._Localidad.length < 2){
              this.$notify({
                group: 'Notificaciones',
                title: 'Localidad inválida!',//Puede ser HTML
                type: 'error',
                speed: 500,
                duration: 3000,
                // text: 'Hello user! This is a notification!'//Puede ser HTML
              });
              _Retorno = false;
            }
            if (this.InfoEstablecimiento._Latitud.length < 2){
              this.$notify({
                group: 'Notificaciones',
                title: 'Latitud inválida!',//Puede ser HTML
                type: 'error',
                speed: 500,
                duration: 3000,
                // text: 'Hello user! This is a notification!'//Puede ser HTML
              });
              _Retorno = false;
            }
            if (this.InfoEstablecimiento._Longitud.length < 2){
              this.$notify({
                group: 'Notificaciones',
                title: 'Longitud inválido!',//Puede ser HTML
                type: 'error',
                speed: 500,
                duration: 3000,
                // text: 'Hello user! This is a notification!'//Puede ser HTML
              });
              _Retorno = false;
            }
        } catch (error) {
          console.error(error);
        }
        return _Retorno;
      },
      LimpiarDatos(){
        this.InfoEstablecimiento._Nombre = "";
        this.InfoEstablecimiento._Localidad = "";
        this.InfoEstablecimiento._Latitud = "";
        this.InfoEstablecimiento._Longitud = "";
      }
    },
  };
</script>
<style lang="scss" scoped>
    $AgroIdeas: #005625;
    $text-dark: #444;
    $navy-blue: #999;

    .face {
        width: 100%;
        padding: 0px 10px;
        box-sizing: border-box;

        .content {
            color: $text-dark;
            h2 {
            font-size: 1.2em;
            color: $AgroIdeas;
            }
            .field-wrapper {
            margin-top: 20px;
            position: relative;

            label {
                position: absolute;
                pointer-events: none;
                font-size: 0.85em;
                top: 40%;
                left: 0;
                transform: translateY(-5px);
                transition: all ease-in 0.25s;
                color: lighten($text-dark, 20%);
            }
            input[type="text"],
            input[type="password"],
            input[type="submit"],
            textarea {
                -webkit-appearance: none;
                appearance: none;
                &:focus {
                outline: none;
                }
            }
            input[type="text"],
            input[type="password"],
            textarea {
                width: 100%;
                border: none;
                background: transparent;
                line-height: 2em;
                border-bottom: 1px solid $AgroIdeas;
                color: $text-dark;

                &::-webkit-input-placeholder {
                opacity: 0;
                }
                &::-moz-placeholder {
                opacity: 0;
                }
                &:-ms-input-placeholder {
                opacity: 0;
                }
                &:-moz-placeholder {
                opacity: 0;
                }
                &:focus,
                &:not(:placeholder-shown) {
                + label {
                    top: -35%;
                    color: $navy-blue;
                }
                }
            }
            textarea {
                resize: none;
                line-height: 1em;
                &:focus,
                &:not(:placeholder-shown) {
                + label {
                    top: -25%;
                }
                }
            }
            }
        }
    }


    .modal-fade-enter, .modal-fade-leave-active {
        opacity: 0;
    }
    .modal-fade-enter-active, .modal-fade-leave-active {
        transition: opacity .2s ease
    }
    .modal-backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 11;
    }
    .modal {
        background: #FFFFFF;
        box-shadow: 0px 0px 10px #222;
        overflow-x: auto;
        display: flex;
        flex-direction: column;
        width: 95%;
        max-width: 500px;

        position: fixed;
        justify-content: center;
        z-index: 11;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .modal-header,
    .modal-footer {
        padding: 15px;
        display: flex;
        // border-top: 1px solid #eeeeee;
        justify-content: space-between;
    }
    .modal-header {
        border-bottom: 1px solid #eeeeee;
        font-weight: bold;
        background: rgba(0,0,0,0.8);
        color: #CCC;
    }
    .modal-footer {
        margin-top:20px;
    }
    .Boton{
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        cursor: pointer;
        width: 100px;
        line-height: 2em;
        color: #fff;
        border: 1px solid #000;
        border-radius: 3px;
        padding: 5px;
        &:hover {
            opacity: 0.9;
        }
        &:active {
            transform: scale(0.96);
        }
    }
    .BotonCancelar {
        background: #999;
    }
    .BotonAceptar {
        background: $AgroIdeas;
    }
</style>
